import React from "react";
import Button from "../../../../components/Button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  CloseArenaDialog,
} from "../../../../redux/arena-dialog/action";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
type Props = {
  style?: React.CSSProperties;
};

const WatchBoxEmptyState: React.FC<Props> = ({ style }) => {
  const dispatch = useDispatch();
  const { t } = useAppTranslation("battle");
  return (
    <div
      style={style}
      className="d-flex flex-column gap-2 align-items-center justify-content-center"
    >
      <div className="dark-yellow">{t("watchEmpty.noBattle")}</div>
      <Link
        onClick={() => dispatch(CloseArenaDialog())}
        to="/arena/watch?mode=history"
      >
        <Button
          variant="default"
          className="bg-100 text-yellow-2 mt-2 px-lg-3 "
        >
          {t("watchEmpty.history")}
        </Button>
      </Link>
    </div>
  );
};

export default WatchBoxEmptyState;
